import { gql, useMutation } from '@apollo/client';
import { meWithTutorialQuery } from 'graphql/queries';
import {
  CreateTutorialGame,
  GameStatus,
  MeWithTutorialQuery,
} from 'graphql/types';
import { useCallback } from 'react';
import { useMutationErrorHandler } from 'utils/mutation-utils';

export function useCreateTutorial() {
  const handleError = useMutationErrorHandler();
  const [createTutorialGame, { loading, called }] =
    useMutation<CreateTutorialGame>(createTutorialGameMutation, {
      update: (cache, { data }) => {
        let newGameData = cache.readQuery<MeWithTutorialQuery>({
          query: meWithTutorialQuery,
        });
        if (newGameData === null) return null;
        cache.writeQuery({
          query: meWithTutorialQuery,
          data: {
            me: {
              ...newGameData.me,
              tutorial: {
                ...newGameData.me?.tutorial,
                game: {
                  id: data?.createTutorialGame.id,
                  status: GameStatus.ACTIVE,
                },
              },
            },
          },
        });
      },
      onError: handleError,
    });

  const createTutorial = useCallback(async () => {
    const result = await createTutorialGame();
    if (result?.data == null) {
      return;
    }
    return result.data.createTutorialGame.id;
  }, [createTutorialGame]);

  return [createTutorial, { loading, called }] as const;
}

const createTutorialGameMutation = gql`
  mutation CreateTutorialGame {
    createTutorialGame {
      id
    }
  }
`;
